"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DestinationPickerValue = void 0;
var _react = _interopRequireDefault(require("react"));
var DestinationPickerValue = exports.DestinationPickerValue = function DestinationPickerValue(_ref) {
  var _currentValue$destina;
  var isDisabled = _ref.isDisabled,
    currentValue = _ref.currentValue,
    children = _ref.children;
  return isDisabled && currentValue ? /*#__PURE__*/_react["default"].createElement("span", null, currentValue.label || ((_currentValue$destina = currentValue.destination) === null || _currentValue$destina === void 0 ? void 0 : _currentValue$destina.label)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};